import React from 'react';
import { Typography, Box } from '@mui/material';
import '../css/Homepage.css';

const NewHome = () => {

  return (
    <Box
      className="hero-container"
      sx={{
        position: 'relative',
        minHeight: '100vh',
      }}
    >
      <Box
        className="overlay"
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(0,0,0,0.45)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          pt: { xs: '12vh', sm: '14vh', md: '16vh' },
          px: 0,
        }}
      >
        <Box
          className="content"
          sx={{
            ml: { xs: 2, sm: 4, md: 8 },
            maxWidth: { xs: '92vw', sm: '80vw', md: '60vw', lg: '45vw' },
          }}
        >
        <Typography
            variant="h2"
            component="h2"
            gutterBottom
            sx={{
                textShadow: 'black 3px 0 10px',
                fontWeight: 'bold' }}>
                        Medigap Life
                    </Typography>
          <Typography
            variant="h5"
            component="p"
            sx={{
              textShadow: 'black 2px 0 10px',
              lineHeight: 1.4,
            }}
          >
            We are committed to transforming Medicare decisions into empowering life choices,
            leading the industry with integrity, innovation, and an unwavering dedication to the people we serve.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NewHome;
